import moment from "moment";
import * as FORM_KEYS from "../consts/formKeys";
import { dateStringAustraliatoDate } from "../components/DatePicker/DatePickerHelper";

const isEmpty = value => {
  if (value && value.trim()) {
    return false;
  } else {
    return true;
  }
};

const isMobile = value => {
  if (value.indexOf("04") === 0 && value.length === 10) {
    return true;
  }
  return false;
};

const isEmail = value => {
  if (/^\b[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,25}\b$/i.test(value)) {
    return true;
  }
  return false;
};

export const validators = {
  [FORM_KEYS.FIRST_NAME]: {
    required: value => {
      if (isEmpty(value)) {
        return "Firstname is required";
      } else {
        return "";
      }
    }
  },
  [FORM_KEYS.LAST_NAME]: {
    required: value => {
      if (isEmpty(value)) {
        return "Lastname is required";
      } else {
        return "";
      }
    }
  },
  [FORM_KEYS.DATE_OF_BIRTH]: {
    required: value => {
      if (!value) return "Date of birth is required";
      return "";
    },
    earlierThanToday: value => {
      if (moment(value, "DD/MM/YYYY") > moment()) {
        return "Date of birth needs to be ealier than today";
      }
      return "";
    },
    valid: value => {
      if (dateStringAustraliatoDate(value) === undefined) {
        return "Valid date format is dd/mm/yyyy";
      }
      return "";
    }
  },
  [FORM_KEYS.MOBILE]: {
    required: value => {
      if (isEmpty(value)) {
        return "Mobile number is required";
      } else {
        return "";
      }
    },
    valid: value => {
      if (!isMobile(value)) {
        return "Mobile number needs to be 10 digit numbers starting with 04";
      } else {
        return "";
      }
    }
  },
  [FORM_KEYS.EMAIL]: {
    required: value => {
      if (isEmpty(value)) {
        return "Email is required";
      } else {
        return "";
      }
    },
    valid: value => {
      if (!isEmail(value)) {
        return "Invalid email. Please use letters, numbers, underscores and periods.";
      } else {
        return "";
      }
    }
  },
  [FORM_KEYS.CONFIRM_EMAIL]: {
    match: (value, compareTo) => {
      return value !== compareTo ? "Email does not match" : "";
    }
  },
  [FORM_KEYS.HEALTH_FUND]: {
    valid: () => {
      return "";
    }
  },
  [FORM_KEYS.CUSTOM_FIELDS]: {
    valid: () => {
      return "";
    }
  },
  [FORM_KEYS.CARD_NUMBER]: {
    valid: () => {
      return "";
    }
  },
  [FORM_KEYS.CARD_POSITION]: {
    valid: () => {
      return "";
    }
  }
};

export const validate = (rules, value, ...args) => {
  let errorMessage = "";
  const keys = Object.keys(rules);
  for (let key of keys) {
    errorMessage = rules[key](value, args[0]);
    if (errorMessage) {
      break;
    }
  }
  return errorMessage;
};



// WEBPACK FOOTER //
// ./src/modules/ContactForm/helpers/validationHelpers.js